import { useId } from "react";

export const PAGE_SIZE_OPTIONS = [10, 25, 50] as const;
export const DEFAULT_PAGE_SIZE = 25;

export function PageSizeSelect({
  value,
  onChange,
  label = "Per page"
}: {
  value: number;
  onChange: (size: number) => void;
  label?: string;
}) {
  const id = useId();
  return (
    <span className="directory-inline-field">
      <label htmlFor={id}>{label}</label>
      <select id={id} className="directory-select" value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {PAGE_SIZE_OPTIONS.map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
    </span>
  );
}

/** Pagination footer matching the Approvals page behaviour (range, per-page, Previous / Next). */
export function DirectoryPagination({
  page,
  pageSize,
  total,
  offset,
  itemCount,
  noun,
  onPageChange,
  onPageSizeChange
}: {
  page: number;
  pageSize: number;
  total: number;
  offset: number;
  itemCount: number;
  noun: string;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}) {
  const rangeStart = total === 0 ? 0 : offset + 1;
  const rangeEnd = total === 0 ? 0 : offset + itemCount;
  const totalPages = total > 0 ? Math.ceil(total / pageSize) : 0;
  const canPrev = page > 0;
  const canNext = total > 0 && (page + 1) * pageSize < total;

  return (
    <nav className="approvals-footer-bar directory-footer" aria-label={`${noun} pagination`}>
      <span>
        Showing <strong>{rangeStart}</strong>–<strong>{rangeEnd}</strong> of <strong>{total}</strong> {noun}
      </span>
      <div className="directory-footer-controls">
        <PageSizeSelect value={pageSize} onChange={onPageSizeChange} />
        <div className="directory-pager">
          <button
            type="button"
            className="directory-page-btn"
            onClick={() => onPageChange(Math.max(0, page - 1))}
            disabled={!canPrev}
          >
            Previous
          </button>
          <span className="directory-pager-status">
            Page {page + 1} of {Math.max(totalPages, 1)}
          </span>
          <button
            type="button"
            className="directory-page-btn"
            onClick={() => onPageChange(page + 1)}
            disabled={!canNext}
          >
            Next
          </button>
        </div>
      </div>
    </nav>
  );
}
